// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"lw","cardContent":"lx","editButton":"ly","innerHeading":"lz","header":"lA","subHeader":"lB"};